import { useContext } from "react";
import { ThemeContext } from "./context/themeContext";
import { ConfigProvider } from "antd";

export const THEME_COLORS = {
    primary: {
        colorPrimary: "#FE5F7B",
        colorPrimaryHover: "#7e57ff",
        colorLink: "#9747ff",
        headerBg: "#FE5F7B",
        optionSelectedBg: "#FE5F7B",
        stepsColorPrimary: "black",
    },
    secondary: {
        colorPrimary: "#ee8533",
        colorPrimaryHover: "#0A6BCD",
        colorLink: "#0d599b",
        headerBg: "#0d599b",
        optionSelectedBg: "#0d599b",
        stepsColorPrimary: "red",
    },
    // PrimeMedicalTheme – used by Prime Medical
    // Finished stepper uses same green as primary theme (#00ff75); header/links stay blue
    primemedicaltheme: {
        colorPrimary: "#f38524",
        colorPrimaryHover: "#297bbf",
        colorLink: "#297bbf",
        headerBg: "#297bbf",
        optionSelectedBg: "#297bbf",
        stepsColorPrimary: "#00ff75",
    },
};

const ThemeConfig = ({ children }) => {
    const { theme } = useContext(ThemeContext);
    const colors = THEME_COLORS[theme] || THEME_COLORS.primary;

    return (
        <ConfigProvider
            theme={{
                token: {
                    fontFamily: 'poppinsregular',
                    colorPrimary: colors.colorPrimary,
                    colorPrimaryHover: colors.colorPrimaryHover,
                    colorPrimaryBgHover: colors.colorPrimaryHover,
                    colorLink: colors.colorLink,
                },
                components: {
                    Steps: {
                        dotSize: 30,
                        dotCurrentSize: 30,
                        colorPrimary: colors.stepsColorPrimary,
                        iconFontSize: 0,
                    },
                    Layout: {
                        footerPadding: 32,
                        headerHeight: 100,
                        headerBg: colors.headerBg,
                    },
                    Button: {
                        fontWeight: 500,
                        fontSizeLG: "1rem",
                        colorPrimaryHover: colors.colorPrimaryHover,
                        colorPrimaryBgHover: colors.colorPrimaryHover,
                        colorPrimaryActive: colors.colorPrimaryHover,
                    },
                    Input: {
                        colorBgContainer: "#F7F7F7",
                        controlHeight: 36,
                        colorBorder: "#ccc",
                        hoverBg: "#ffffff",
                        activeBg: "#ffffff",
                    },
                    Radio: {
                        fontSize: "0.813rem",
                        fontFamily: 'poppinsmedium',
                    },
                    Select: {
                        optionSelectedBg: colors.optionSelectedBg,
                        optionSelectedColor: "#fff",
                        controlHeightLG: 40,
                        fontSizeLG: "0.813rem",
                        optionFontSize: "0.813rem",
                        optionSelectedFontWeight: 500,
                        colorBorder: "#000000",
                        colorPrimaryBorderHover: "green",
                        colorTextPlaceholder: "#000000",
                        fontWeightStrong: 700,
                    },
                    Form: {
                        itemMarginBottom: 12,
                        colorError: "red",
                        fontSize: "0.813rem",
                        labelFontSize: "0.813rem"
                    },
                    DatePicker: {
                        controlHeight: 36,
                        colorBgContainer: "#F7F7F7",
                        hoverBg: "#ffffff",
                        activeBg: "#ffffff",
                        fontSize: "0.813rem"
                    },
                    Tree: {
                        colorBorder: "#000000",
                        fontSize: "0.813rem",
                        fontFamily: 'poppinsmedium',
                    },
                    Card: {
                        boxShadowTertiary: false,
                    },
                    Checkbox: {
                        fontSize: "0.938rem",
                        colorPrimaryHover: colors.colorPrimaryHover,
                    }
                },
            }}
        >
            {children}
        </ConfigProvider>
    )
}

export default ThemeConfig
